module.exports = __webpack_public_path__ + "img/vlLogo_color_noBG.387ee1a2.png";